import { routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import { all, call } from "redux-saga/effects";

import { createFirestoreInstance } from "redux-firestore";
import { firebase } from "./firebase";
import rootSaga from "./rootSaga";
import { initAction, initSaga } from "./initializers";
import createReducer from "./rootReducer";

export const history = createBrowserHistory();
const sagaMiddleware = createSagaMiddleware();

// react-redux-firebase config
const rrfConfig = {
  userProfile: "users",
  useFirestoreForProfile: true // Firestore for Profile instead of Realtime DB
};

export function configureStore() {
  const middleware = composeWithDevTools(applyMiddleware(sagaMiddleware, routerMiddleware(history)));

  const store = createStore(createReducer(history), middleware);
  sagaMiddleware.run(sagas);
  store.dispatch(initAction);

  const rrfProps = {
    firebase,
    config: rrfConfig,
    dispatch: store.dispatch,
    createFirestoreInstance
  };

  return { store, rrfProps };
}

function* sagas() {
  yield all([rootSaga, initSaga].map(call));
}
